/*
* @requires  seal-websocket.js
*/

var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {


    /**
     * @param param
     * {
     *     context：签章环境.
     *     success:
     *     fail:
     * }
     * @constructor
     */
    function Seal(param) {
        //根据当前浏览器环境，自动判断采用哪种实现。目前仅支持websocket
        this.imp=new $m.SealWebsocket(param,this,null);
        //this.imp.setEventCallback(this,null);
        this.middleware=null;
    }

    /**
     * 设置环境
     * @param param
     * {
     *     context: name,
     *     contextType: 环境类型,
     *     config: 环境配置,
     *     success:
     *     fail:
     * }
     */
    Seal.prototype.setContext=function (param){
        if(!param.context || !param.contextType || !param.config){
            if(param.fail){
                param.fail(new Error("缺少参数"));
                return;
            }
        }
        this.imp.context=param.context;
        this.imp.setContext(param);
    }

    Seal.prototype.getContext=function (param){
        if(!param.context){
            param.context=this.imp.context;
        }
        this.imp.getContext(param);
    }

    Seal.prototype.getContexts=function (param){
        this.imp.getContexts(param);
    }

    /**
     * 列举印章
     * @param param
     * {
     *      certSn: xxx, 证书序列号，可选，如果设置证书序列号，则只列举该证书的印章
     *      success：function(seals){}
     *              seals印章列表，数组，其中对象包括：
     *              {
     *                  sealSn: 印章序列号
     *                  sealName: 印章名称
     *                  context： 印章环境名称
     *                  certSn： 证书序列号
     *                  isCertLogined：证书是否已登录
     *              }
     *      fail: function(e){}
     * }
     */
    Seal.prototype.listSeal=function (param) {
        this.imp.listSeal(param);
    };

    /**
     * 获取印章数据
     * @param param
     * {
     *     sealSn: 印章序列号
     *     success：function(seal){}
     *     fail: function(e){}
     * }
     */
    Seal.prototype.getSealB64=function (param) {
        this.imp.getSealB64(param);
    };

    /**
     * 解析印章数据
     * @param param
     * {
     *     sealSn: 可选，印章序列号，如果提供印章序列号，则从通过印章序列号找到用户印章
     *     seal: 可选，印章数据，seal和sealSn必须二选一，如果都设置，则seal优先。
     *     success：function(sealInfo){}
     *              sealInfo对象：
     *              {
     *                  sealSn： string 印章序列号
     *                  formatType：string 印章格式
     *                  issuerCert：cert object 签发者证书对象，见middle证书对象
     *                  userCerts: array of cert object 用户证书
     *                  startTime：开始时间
     *                  endTime： 结束时间
     *                  sealName： 印章名称
     *                  sealType: 印章类型
     *                  vid: 印章厂商标识
     *                  pictureInfo： object 印章图片信息
     *                  {
     *                      type string  图片格式
     *                      data string  图片数据B64
     *                      width int    //图片宽度，单位毫米
     *                      height int   //图片高度，单位毫米
     *                  }
     *                  issuerTime：签发时间
     *                  certSn: 证书序列号
     *                  isCertLogined: 证书是否已登录
     *               }
     *     fail: function(e){}
     */
    Seal.prototype.getSealInfo=function (param) {
        this.imp.getSealInfo(param);
    };

    /**
     * 选择印章，如果设置了ui，则采用js层UI，否则使用go中间件层UI
     * @param param
     * {
     *     certSn: xxx, 证书序列号，可选，如果设置证书序列号，则只列举该证书的印章
     *     success：function(seal){}
     *     fail: function(e){}
     * }
     */
    Seal.prototype.selectSeal=function(param){
        if($m._ui && $m._ui.selectSeal){
            //如果设置了UI，则使用js层UI
            var that=this;
            var seq=new $m.Seq();
            seq.then(function () {
                that.listSeal({
                    certSn: (param && param.certSn)? param.certSn: undefined,
                    success: function (seals) {
                       seq.resolve(seals);
                    },
                    fail: function (e) {
                        seq.reject(e);
                    }
                });
            }).then(function (seq,seals) {
                if(seals.length===0){
                    seq.reject(new Error("没有找到印章"));
                }
                else if(seals.length===1){
                    seq.resolve(seals[0]);
                }
                else{
                    //多个印章，选择
                    $m._ui.selectSeal({
                        seals: seals,
                        success: function (seal) {
                            seq.resolve(seal);
                        },
                        fail: function (e) {
                            seq.reject(e);
                        }
                    })
                }
            })
            .then(function (seq,seal) {
                $m.util.success(param,seal);
            })
            .onerror(function (e) {
                $m.util.fail(param,e);
            });

            seq.run();
        }
        else{
            this.imp.selectSeal(param);
        }
    };

    Seal.prototype.showSeals=function (param){
        var that=this;
        var seq=new $m.Seq();
        seq.thenEach(param.show,function (seq,index){
            var p={
                show: param.show[index],
                success: function (){
                    seq.resolve(index+1)
                },
                fail: function (e){
                    seq.reject(e)
                }
            }
            if(param.verify){
                p.verify=param.verify[index]
            }
            if(param.sealSignature){
                p.sealSignature=param.sealSignature[index]
            }
            if(param.signSealData){
                p.cert=param.signSealData[index].cert
                p.signature=param.signSealData[index].signature
                p.seal=param.signSealData[index].seal
                p.timeStamp= param.signSealData[index].timeStamp
                p.signTime=param.signSealData[index].signTime
            }

            that.showSeal(p)
        }).then(function (){
            param.success()
        }).onerror(function (e) {
            $m.util.fail(param,e);
        }).run(0);
    };

    /**
     * 显示印章
     * @param param
     * {
     *     sealSignature:
     *     seal:
     *     cert:
     *     timeStamp:
     *     signTime:
     *     verify
     *     show: {
     *         divId:
     *         ui:
     *     }
     * }
     * @private
     */
    Seal.prototype.showSeal=function (param){
        var that=this;
        var seq=new $m.Seq();
        var info={}
        seq.then(function (){
            if(param.sealSignature){
                that.getSealSignatureInfo({
                    sealSignature: param.sealSignature,
                    success:function (signatureInfo) {
                        info.sealSignatureInfo=signatureInfo
                        var container=document.getElementById(param.show.divId);
                        if(info.sealSignatureInfo.seal){
                            param.typeDesc="签章"
                            container.innerHTML="<img id='"+param.show.divId+"_seal' src='data:image/"+signatureInfo.seal.pictureInfo.type+";base64,"+signatureInfo.seal.pictureInfo.data+"' style='width: "+signatureInfo.seal.pictureInfo.width+"mm; height: "+signatureInfo.seal.pictureInfo.height+"mm;' />";
                            if(param.verify && param.verify.verify===false){
                                that._showVerifyError(param,signatureInfo.seal.pictureInfo);
                            }
                        } else {
                            param.typeDesc="签批"
                            container.innerHTML="<img id='"+param.show.divId+"_seal' src='data:image/gif;base64,"+signatureInfo.signPic.pic+"' />";
                            if(param.verify && param.verify.verify===false){
                                //that._showVerifyError(param,signatureInfo.seal.pictureInfo);
                            }
                        }

                        seq.resolve()
                    },
                    fail:function (e) {
                        seq.reject(e);
                    }
                })
            }else {
                that._getSignSealInfos({
                    seal: param.seal,
                    cert: param.cert,
                    timeStamp: param.timeStamp,
                    signTime: param.signTime,
                    success:function (signInfoes) {
                        param.typeDesc="签章"
                        info.sealInfo=signInfoes.sealInfo
                        info.certInfo=signInfoes.certInfo
                        info.timeStampInfo=signInfoes.timeStampInfo
                        info.signTime=signInfoes.signTime
                        var container=document.getElementById(param.show.divId);
                        container.innerHTML="<img id='"+param.show.divId+"_seal' src='data:image/"+signInfoes.sealInfo.pictureInfo.type+";base64,"+signInfoes.sealInfo.pictureInfo.data+"' style='width: "+signInfoes.sealInfo.pictureInfo.width+"mm; height: "+signInfoes.sealInfo.pictureInfo.height+"mm;' />";
                        if(param.verify && param.verify.verify===false){
                            that._showVerifyError(param,signInfoes.sealInfo.pictureInfo);
                        }
                        seq.resolve()
                    },
                    fail:function (e) {
                        seq.reject(e);
                    }
                })
            }

        }).then(function (){
            var ui=null;
            if(param.show.ui){
                ui=param.show.ui
            }else{
                ui=$m._ui
            }

            if(ui){
                that._addContextMenuToSeal({
                    ui: ui,
                    divId: param.show.divId,
                    verify: param.verify,
                    typeDesc: param.typeDesc,
                    sealSignatureInfo: info.sealSignatureInfo,
                    sealInfo: info.sealInfo,
                    certInfo: info.certInfo,
                    timeStampInfo: info.timeStampInfo,
                    signTime: info.signTime
                })

                var sealName=''
                if(info.sealSignatureInfo){
                    if(info.sealSignatureInfo.seal){
                        sealName=info.sealSignatureInfo.seal.sealName
                    }
                }else{
                    sealName=info.sealInfo.sealName
                }

                if(param.verify){
                    if(sealName!==''){
                        ui.addTooltip({
                            divId: param.show.divId,
                            tooltip: param.typeDesc+":"+sealName+"，"+(param.verify.verify===true?"验证成功":"验证失败: "+param.verify.error.message)
                        })
                    } else {
                        ui.addTooltip({
                            divId: param.show.divId,
                            tooltip: "签批"+(param.verify.verify===true?"验证成功":"验证失败: "+param.verify.error.message)
                        })
                    }
                }

                seq.resolve()
            }else{
                seq.resolve()
            }
        }).then(function (){
            if(param.success){
                param.success()
            }
        }).onerror(function (e){
            if(param.fail){
                param.fail(e)
            }
        }).run();

    };

    Seal.prototype._showVerifyError=function (param,pictureInfo){
        var container=document.getElementById(param.show.divId);
        container.style.position="relative";
        var firstLine="<div style='display: inline-block; position: absolute; top: "+pictureInfo.height*2/8+"mm;  left: 0px; background-color: rgba(169,169,169,0.8); height: "+pictureInfo.height/8+"mm;width: "+pictureInfo.width+"mm' ></div>"
        var secondLine="<div style='display: inline-block; position: absolute; top: "+pictureInfo.height*5/8+"mm;  left: 0px; background-color: rgba(169,169,169,0.8);; height: "+pictureInfo.height/8+"mm;width: "+pictureInfo.width+"mm'></div>"
        container.innerHTML=container.innerHTML+firstLine+secondLine
    };

    /**
     *
     * @param param
     * {
     *     seal:
     *     cert:
     *     timeStamp:
     *     signTime:
     * }
     * @private
     */
    Seal.prototype._getSignSealInfos=function(param){
        var that=this;
        var seq=new $m.Seq();
        var ret={}
        var m=null;
        seq.then(function (){
            that.getSealInfo({
                seal: param.seal,
                success:function (sealInfo) {
                    ret.sealInfo=sealInfo
                    seq.resolve()
                },
                fail:function (e) {
                    seq.reject(e);
                }
            })
        }).then(function (){
            that._getMiddleware({
                success:function (middleware){
                    m=middleware
                    seq.resolve()
                },
                fail:function (e){
                    seq.reject(e)
                }
            })

        }).then(function (){
            m.getCertInfo({
                cert: param.cert,
                success:function (certInfo) {
                    ret.certInfo=certInfo
                    seq.resolve()
                },
                fail:function (e) {
                    seq.reject(e);
                }
            })
        }).then(function (){
            if(param.timeStamp){
                m.getTimeStampInfo({
                    timeStamp: param.timeStamp,
                    success:function (timestampInfo){
                        ret.timeStampInfo=timestampInfo;
                        seq.resolve()
                    }
                })
            }else{
                ret.signTime=param.signTime
                seq.resolve()
            }
        }).then(function (){
            if(param.timeStamp){
                m.getCertInfo({
                    cert: ret.timeStampInfo.cert,
                    success:function (certInfo){
                        ret.timeStampInfo.signCert=certInfo;
                        seq.resolve()
                    }
                })
            }else{
                seq.resolve()
            }
        }).then(function (){
            param.success(ret)
        }).onerror(function (e){
            param.fail(e)
        }).run();

    };

    /**
     * 添加右键菜单
     * @param param
     * {
     *     ui:
     *     divId:
     *     verify:
     *     sealSignatureInfo:
     *     sealInfo:
     *     certInfo:
     *     timeStampInfo:
     *     signTime:
     * }
     */
    Seal.prototype._addContextMenuToSeal=function(param){
        var actions=[];
        var that=this;
        if(param.verify){
            actions.push({
                name: "验证结果",
                onClick: function () {
                    if(param.verify.verify){
                        alert(param.typeDesc+"验证通过");
                    }
                    else{
                        alert(param.typeDesc+"验证失败: "+param.verify.error.message);
                    }
                }
            });
        }

        actions.push({
            name: param.typeDesc+"信息",
            onClick: function () {
                that._showSealSignatureInfo(param);
            }
        });

        if(param.sealSignatureInfo&&!param.sealSignatureInfo.seal){
            //没有印章
        }else{
            actions.push({
                name: "印章信息",
                onClick: function () {
                    that._showSealInfo(param);
                }
            });
        }


        if(param.ui && param.ui.addContextMenu){
            param.ui.addContextMenu({
                divId:param.divId+"_seal",
                actions:actions
            });
        }
    };

    /**
     * 显示签章信息
     * @param param
     * {
     *     ui:
     *     divId:
     *     verify:
     *     sealSignatureInfo:
     *     sealInfo:
     *     certInfo:
     *     timeStampInfo:
     *     signTime:
     * }
     */
    Seal.prototype._showSealSignatureInfo=function(param) {
        var p={
            id: "__hebca_sealSigantureInfoDialog",
            title: param.typeDesc+"信息",
            infoes: []
        };

        var certInfo=null;
        var timeStampInfo=null;
        var signTime;
        if(param.sealSignatureInfo){
            certInfo=param.sealSignatureInfo.signCert
            timeStampInfo=param.sealSignatureInfo.timeStamp
            signTime=param.sealSignatureInfo.signTime
        }else{
            certInfo=param.certInfo
            timeStampInfo=param.timeStampInfo
            signTime=param.signTime
        }

        //签章信息
        var signTimeStr="";
        if(timeStampInfo)
            signTimeStr = timeStampInfo.time+ "(时间戳时间)";
        else
            signTimeStr = signTime;

        var that=this;
        var group1={
            caption: param.typeDesc+"信息",
            items: [{
                    name: param.typeDesc+"人",
                    value: param.typeDesc+"人证书",
                    onClick: function (){
                        that._showCertInfo({
                            ui:param.ui,
                            title: param.typeDesc+"人证书",
                            cert: certInfo
                        })
                    }
                },
                {
                    name: param.typeDesc+"时间",
                    value: signTimeStr
                },
            ]
        };

        if(timeStampInfo){
            group1.items.push({
                name: "时间戳证书",
                value: "时间戳证书",
                onClick: function (){
                    that._showCertInfo({
                        ui:param.ui,
                        title: "时间戳证书",
                        cert: timeStampInfo.signCert
                    })
                }
            })
        }

        p.infoes.push(group1);
        param.ui.showInfo(p);
    };

    /**
     * 显示印章信息
     * @param param
     * @private
     */
    Seal.prototype._showSealInfo=function (param){
        var p={
            id: "__hebca_sealInfoDialog",
            title: "印章信息",
            infoes: []
        };

        var sealInfo=null;
        if(param.sealSignatureInfo){
            sealInfo=param.sealSignatureInfo.seal
        }else{
            sealInfo=param.sealInfo
        }

        var that=this;
        var group1={
            caption: "印章信息",
            items: [{
                    name: "印章名称",
                    value: sealInfo.sealName
                },
                {
                    name: "印章序列号",
                    value: sealInfo.sealSn
                },
                {
                    name: "印章有效期起始",
                    value: sealInfo.startTime
                },
                {
                    name: "印章有效期终止",
                    value: sealInfo.endTime
                },
                {
                    name:"印章签发时间",
                    value: sealInfo.issuerTime
                },
                {
                    name:"印章",
                    value: "<img src='data:image/"+sealInfo.pictureInfo.type+";base64,"+sealInfo.pictureInfo.data+"' style='width: "+sealInfo.pictureInfo.width+"mm; height: "+sealInfo.pictureInfo.height+"mm;' />"
                }
            ]
        };

        if(sealInfo.issuerCert){
            group1.items.push(
                {
                    name: "制章人",
                    value: "制章人证书",
                    onClick: function () {
                        that._showCertInfo({
                            ui: param.ui,
                            title: "制章人证书",
                            cert: sealInfo.issuerCert
                        })
                    }
                }
            )
        }

        if(sealInfo.userCerts){
            if(sealInfo.userCerts.length===1) {
                group1.items.push(
                    {
                        name: "印章所有者",
                        value: "印章所有者证书",
                        onClick: function () {
                            that._showCertInfo({
                                ui: param.ui,
                                title: "印章所有者证书",
                                cert: sealInfo.userCerts[0]
                            })
                        }
                    }
                )
            }else{
                for(var i=0;i<sealInfo.userCerts.length;i++){
                    group1.items.push(
                        {
                            name: "印章所有者"+(i+1),
                            value: "印章所有者证书"+(i+1),
                            onClick: function () {
                                that._showCertInfo({
                                    ui: param.ui,
                                    title: "印章所有者证书"+(i+1),
                                    cert: sealInfo.userCerts[i]
                                })
                            }
                        }
                    )
                }
            }
        }

        p.infoes.push(group1);
        param.ui.showInfo(p);
    };

    /**
     * 显示证书信息
     * @param param
     * {
     *     ui: UI实现对象,
     *     title:
     *     cert: 证书对象,
     * }
     */
    Seal.prototype._showCertInfo=function(param) {
        var p={
            id: "__hebca_certInfoDialog",
            title: param.title,
            infoes: []
        };

        var group1={
            caption: "证书信息",
            items: [{
                    name: "证书持有者",
                    value: param.cert.subject.cn
                },
                {
                    name: "证书持有者GivenName",
                    value: param.cert.subject.g===undefined?"":param.cert.subject.g
                },
                {
                    name: "证书序列号",
                    value: param.cert.sn
                },
                {
                    name: "证书有效期起始",
                    value: param.cert.notBefore
                },
                {
                    name: "证书有效期终止",
                    value: param.cert.notAfter
                },
                {
                    name: "算法",
                    value: param.cert.alg
                },
                {
                    name: "签发者",
                    value: param.cert.issuer.cn
                }
            ]
        };

        p.infoes.push(group1);
        param.ui.showInfo(p);
    };

    Seal.prototype._getMiddleware=function (param){
        if(this.middleware){
            param.success(this.middleware)
        }else{
            this.middleware=new $m.Middleware(param)
        }
    };

    Seal.prototype._assertSealLogined=function (param,next){
        var that=this;
        var seq=new $m.Seq();
        var selectSealSn=null;
        seq.then(function () {
            //选择sealSN
            if (param && param.sealSn) {
                that.getSealInfo({
                    sealSn: param.sealSn,
                    success: function (sealInfo){
                        seq.resolve(sealInfo)
                    },
                    fail:function (e){
                        seq.reject(e)
                    }
                })
            } else {
                //未指定sealSN
                that.selectSeal({
                    success: function (seal) {
                        param.sealSn=seal.sealSn
                        seq.resolve(seal)
                    },
                    fail: function (e) {
                        seq.reject(e)
                    }
                });
            }
        }).then(function (seq,seal){
            //检查登录
            //如果已登录，
            if(seal.isCertLogined ){
                next() //完成
                return;
            }

            if((!param.password || param.password==="") && $m._ui && $m._ui.loginSeal) {
                $m._ui.loginSeal({
                    seal: seal,
                    success:function (password) {
                        param.password=password
                        seq.resolve();
                    },
                    fail: function (e) {
                        seq.reject(e);
                    }
                })
            }else{
                seq.resolve();
            }
        }).then(function (){
            that.imp.loginSeal({
                sealSn: param.sealSn,
                password: param.password,
                success:function () {
                    next()
                },
                fail: function (e) {
                    seq.reject(e);
                }
            })
        }).onerror(function (e){
            $m.util.fail(param,e);
        }).run();
    };

    /**
     * 登录印章
     * @param param
     * {
     *     sealSn: 印章序列号，可选
     *     password：密码，可选
     *     success:function(){}
     *     fail:function(e){}
     * }
     */
    Seal.prototype.loginSeal=function (param){
        this._assertSealLogined(param,function (){
            $m.util.success(param)
        })
    };

    /**
     * 签章
     * @param param
     * {
     *     data: 签章原文
     *     sealSn: 印章序列号，可选，如为空，且存在多个印章，则弹出对话框选择
     *     dataFormat：原文格式，Base64、Text，可选参数，默认Text
     *     charset: 当原文格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *     password: 登录密码，可选
     *     show: 显示相关选项，可选，如果不提供，则不显示
     *          {
     *              divId： 显示在div中
     *          }
     *     success：function(signature){}
     *     fail: function(e){}
     * }
     */
    Seal.prototype.signSealSignature=function (param) {
        var that=this;
        this._assertSealLogined(param,function (){
            var seq=new $m.Seq();
            seq.then(function () {
                //签章
                var p={
                    sealSn: param.sealSn,
                    success:function (signature) {
                        seq.resolve(signature);
                    },
                    fail:function (e) {
                        seq.reject(e);
                    }
                };
                $m.util.setAttrs(p,param,["data","dataFormat","charset","password","enableTimeStamp"]);
                that.imp.signSealSignature(p);
            }).then(function (seq,signature) {
                //显示
                if(param.show && param.show.divId){
                    that.showSeal({
                        sealSignature: signature,
                        show: param.show,
                        success: function (){
                            seq.resolve(signature)
                        },
                        fail:function (e){
                            seq.reject(e)
                        }
                    })
                }
                else {
                    seq.resolve(signature);
                }
            }).then(function (seq,signature) {
                $m.util.success(param,signature);
            }).onerror(function (e) {
                $m.util.fail(param,e);
            });
            seq.run();
        })
    };

    Seal.prototype.signSealSignatureBatch=function (param) {
        var that=this;
        this._assertSealLogined(param,function (){
            var seq=new $m.Seq();
            seq.then(function () {
                //签章
                var p={
                    sealSn: param.sealSn,
                    success:function (signatures) {
                        seq.resolve(signatures);
                    },
                    fail:function (e) {
                        seq.reject(e);
                    }
                };
                $m.util.setAttrs(p,param,["data","dataFormat","charset","password","enableThreads","enableTimeStamp"]);
                that.imp.signSealSignatureBatch(p);
            }).then(function (seq,signature) {
                //显示
                if(param.show){
                    that.showSeals({
                        sealSignature: signature,
                        show: param.show,
                        success: function (){
                            seq.resolve(signature)
                        },
                        fail:function (e){
                            seq.reject(e)
                        }
                    })
                }
                else {
                    seq.resolve(signature);
                }
            }).then(function (seq,signatures) {
                $m.util.success(param,signatures);
            }).onerror(function (e) {
                $m.util.fail(param,e);
            });
            seq.run();
        })
    };

    /**
     * 验证签章
     * @param param
     * {
     *     sealSignature: 签章结果
     *     data: 签章原文
     *     dataFormat：原文格式，Base64、Text，可选参数，默认Text
     *     charset: 当原文格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *     success：function(){}
     *     fail: function(e){}
     * }
     */
    Seal.prototype.verifySealSignature=function (param) {
        var that=this;
        var seq=new $m.Seq();
        seq.then(function (){
            var p={
                success:function () {
                    seq.resolve({
                        verify: true,
                    });
                },
                fail:function (e) {
                    seq.resolve({
                        verify: false,
                        error: e
                    });
                }
            };
            $m.util.setAttrs(p,param,["hash","data","dataFormat","charset","sealSignature"]);
            that.imp.verifySealSignature(p);
        }).then(function (seq,verify){
            //显示
            if(param.show && param.show.divId){
                that.showSeal({
                    sealSignature: param.sealSignature,
                    show: param.show,
                    verify: verify,
                    success: function (){
                        if(verify.verify){
                            seq.resolve()
                        }else{
                            seq.reject(verify.error)
                        }
                    },
                    fail:function (e){
                        seq.reject(e)
                    }
                })
            }
            else {
                if(verify.verify){
                    seq.resolve()
                }else{
                    seq.reject(verify.error)
                }
            }
        }).then(function (seq,verify) {
            $m.util.success(param,verify);
        }).onerror(function (e) {
            $m.util.fail(param,e);
        }).run();
    };

    Seal.prototype.verifySealSignatureBatch=function (param) {
        var that=this;
        var seq=new $m.Seq();
        seq.then(function (){
            var p={
                success:function (result) {
                    var verifyResult=[]
                    for(var i=0;i<result.length;i++){
                        if(result[i].ok){
                            verifyResult.push({
                                verify: true,
                            });
                        } else {
                            verifyResult.push({
                                verify: false,
                                error: new Error(result[i].errorMessage)
                            });
                        }
                    }
                    seq.resolve(verifyResult)
                },
                fail:function (e) {
                    var verifyResult=[]
                    for(var i=0;i<param.sealSignature.length;i++) {
                        verifyResult.push({
                            verify: false,
                            error: e
                        });
                    }
                    seq.resolve(verifyResult)
                }
            };
            $m.util.setAttrs(p,param,["hash","data","dataFormat","charset","sealSignature"]);
            that.imp.verifySealSignatureBatch(p);
        }).then(function (seq,verify){
            //显示
            if(param.show){
                that.showSeals({
                    sealSignature: param.sealSignature,
                    show: param.show,
                    verify: verify,
                    success: function (){
                        seq.resolve(verify)
                    },
                    fail:function (e){
                        seq.reject(e)
                    }
                })
            }
            else {
                seq.resolve(verify)
            }
        }).then(function (seq,verify) {
            $m.util.success(param,verify);
        }).onerror(function (e) {
            $m.util.fail(param,e);
        }).run();
    };

    /**
     * 解析签章数据
     * @param param
     * {
     *     sealSignature: 签章结果
     *     success：function(signatureInfo){}
     *     fail: function(e){}
     * }
     */
    Seal.prototype.getSealSignatureInfo=function (param) {
        this.imp.getSealSignatureInfo(param);
    };

    /**
     * 分散签章
     * @param param
     * {
     *     data: 签章原文
     *     sealSn: 印章序列号，可选，如为空，且存在多个印章，则弹出对话框选择
     *     dataFormat：原文格式，Base64、Text，可选参数，默认Text
     *     charset: 当原文格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *     password: 登录密码，可选
     *     show: 显示相关选项，可选，如果不提供，则不显示
     *          {
     *              divId： 显示在div中
     *              ui:
     *          }
     *     success：function(signatureInfo){}
     *     fail: function(e){}
     * }
     */
    Seal.prototype.signSeal=function (param) {
        var that=this;
        this._assertSealLogined(param,function (){
            var seq=new $m.Seq();
            seq.then(function () {
                //签章
                var p={
                    sealSn: param.sealSn,
                    success:function (signResult) {
                        seq.resolve(signResult);
                    },
                    fail:function (e) {
                        seq.reject(e);
                    }
                };
                $m.util.setAttrs(p,param,["data","dataFormat","charset","password","certId","ca","enableTimeStamp","timeStampHasCert",
                    "certVerify","sealVerify"]);
                that.imp.signSeal(p);
            }).then(function (seq,signResult) {
                //显示
                if(param.show && param.show.divId){
                    that.showSeal({
                        seal: signResult.seal,
                        cert: signResult.cert,
                        timeStamp:signResult.timeStamp,
                        signTime: signResult.signTime,
                        show: param.show,
                        success:function () {
                            seq.resolve(signResult);
                        },
                        fail:function (e) {
                            seq.reject(e);
                        }
                    })
                }
                else {
                    seq.resolve(signResult);
                }
            })
            .then(function (seq,signResult) {
                $m.util.success(param,signResult);
            })
            .onerror(function (e) {
                $m.util.fail(param,e);
            });
            seq.run();
        })
    };

    Seal.prototype.signSealBatch=function (param) {
        var that=this;
        this._assertSealLogined(param,function (){
            var seq=new $m.Seq();
            seq.then(function () {
                //签章
                var p={
                    sealSn: param.sealSn,
                    success:function (signResults) {
                        seq.resolve(signResults);
                    },
                    fail:function (e) {
                        seq.reject(e);
                    }
                };
                $m.util.setAttrs(p,param,["data","dataFormat","charset","password","certId","ca","enableTimeStamp","timeStampHasCert",
                    "enableThreads","certVerify","sealVerify"]);
                that.imp.signSealBatch(p);
            }).then(function (seq,signResult) {
                //显示
                if(param.show){
                    that.showSeals({
                        signSealData: signResult,
                        show: param.show,
                        success:function () {
                            seq.resolve(signResult);
                        },
                        fail:function (e) {
                            seq.reject(e);
                        }
                    })
                }
                else {
                    seq.resolve(signResult);
                }
            }).then(function (seq,signResults) {
                $m.util.success(param,signResults);
            })
            .onerror(function (e) {
                $m.util.fail(param,e);
            });
            seq.run();
        })
    };

    /**
     * 分散签章验证
     * @param param
     * {
     *     data: 签章原文
     *     dataFormat：原文格式，Base64、Text，可选参数，默认Text
     *     charset: 当原文格式为Text时，原文采用的编码。支持GBK、UTF8，可选参数，默认UTF8
     *     cert: 数字证书
     *     signature: 签名
     *     seal: 印章
     *     timeStamp: 时间戳
     *     signTime: 签名时间
     *     show: 显示相关选项，可选，如果不提供，则不显示
     *          {
     *              divId： 显示在div中
     *          }
     *     success：function(){}
     *     fail: function(e){}
     * }
     */
    Seal.prototype.verifySignSeal=function (param){

        var that=this;
        var seq=new $m.Seq();
        seq.then(function (){
            var p={
                success:function () {
                    seq.resolve({
                        verify: true,
                    });
                },
                fail:function (e) {
                    seq.resolve({
                        verify: false,
                        error: e
                    });
                }
            };
            $m.util.setAttrs(p,param,["data","dataFormat","charset","cert","signature","seal","timeStamp","signTime"]);
            that.imp.verifySignSeal(p);
        }).then(function (seq,verify){
            //显示
            if(param.show && param.show.divId){
                that.showSeal({
                    cert: param.cert,
                    signature: param.signature,
                    seal: param.seal,
                    timeStamp: param.timeStamp,
                    signTime: param.signTime,
                    show: param.show,
                    verify: verify,
                    success: function (){
                        if(verify.verify){
                            seq.resolve()
                        }else{
                            seq.reject(verify.error)
                        }
                    },
                    fail:function (e){
                        seq.reject(e)
                    }
                })
            }
            else {
                if(verify.verify){
                    seq.resolve()
                }else{
                    seq.reject(verify.error)
                }
            }
        }).then(function (seq,verify) {
            $m.util.success(param,verify);
        }).onerror(function (e) {
            $m.util.fail(param,e);
        }).run();
    }

    Seal.prototype.verifySignSealBatch=function (param){

        var that=this;
        var seq=new $m.Seq();
        seq.then(function (){
            var p={
                success:function (result) {
                    var verifyResult=[]
                    for(var i=0;i<result.length;i++){
                        if(result[i].ok){
                            verifyResult.push({
                                verify: true,
                            });
                        } else {
                            verifyResult.push({
                                verify: false,
                                error: new Error(result[i].errorMessage)
                            });
                        }
                    }
                    seq.resolve(verifyResult)
                },
                fail:function (e) {
                    var verifyResult=[]
                    for(var i=0;i<param.signSealData.length;i++) {
                        verifyResult.push({
                            verify: false,
                            error: e
                        });
                    }
                    seq.resolve(verifyResult)
                }
            };
            $m.util.setAttrs(p,param,["signSealData","dataFormat","charset"]);
            that.imp.verifySignSealBatch(p);
        }).then(function (seq,verify){
            //显示
            if(param.show){
                that.showSeals({
                    signSealData: param.signSealData,
                    show: param.show,
                    verify: verify,
                    success: function (){
                        seq.resolve(verify)
                    },
                    fail:function (e){
                        seq.reject(e)
                    }
                })
            }
            else {
                seq.resolve(verify)
            }
        }).then(function (seq,verify) {
            $m.util.success(param,verify);
        }).onerror(function (e) {
            $m.util.fail(param,e);
        }).run();
    }

    /**
     * 向Key写入印章
     * @param param
     */
    Seal.prototype.writeSeals=function (param){
        var seq=new $m.Seq()
        var that=this
        var m=null
        seq.then(function (){
            that._getMiddleware({
                success:function (middleware){
                    m=middleware
                    seq.resolve(m)
                },
                fail:function (e){
                    seq.reject(e)
                }
            })
        }).then(function (seq,m){
            if(!param.certSn){
                m.selectCert({
                    certType:"sign",
                    success:function (cert){
                        param.certSn=cert.sn
                        seq.resolve()
                    },
                    fail:function (e){
                        seq.reject(e)
                    }
                })
            }else{
                seq.resolve()
            }
        }).then(function (){
            if(!param.password){
                m.login({
                    sn:param.certSn,
                    success:function (){
                        seq.resolve()
                    },
                    fail:function (e){
                        seq.reject(e)
                    }
                })
            }else{
                seq.resolve()
            }
        }).then(function (){
            that.imp.writeSeals(param)
        }).onerror(function (e) {
            $m.util.fail(param,e);
        }).run();

    }

    /**
     * 从Key删除印章
     * @param param
     */
    Seal.prototype.deleteSeals=function (param){
        var seq=new $m.Seq()
        var that=this
        var m=null
        seq.then(function (){
            that._getMiddleware({
                success:function (middleware){
                    m=middleware
                    seq.resolve(m)
                },
                fail:function (e){
                    seq.reject(e)
                }
            })
        }).then(function (seq,m){
            if(!param.certSn){
                m.selectCert({
                    certType:"sign",
                    success:function (cert){
                        param.certSn=cert.sn
                        seq.resolve()
                    },
                    fail:function (e){
                        seq.reject(e)
                    }
                })
            }else{
                seq.resolve()
            }
        }).then(function (){
            if(!param.password){
                m.login({
                    sn:param.certSn,
                    success:function (){
                        seq.resolve()
                    },
                    fail:function (e){
                        seq.reject(e)
                    }
                })
            }else{
                seq.resolve()
            }
        }).then(function (){
            that.imp.deleteSeals(param)
        }).onerror(function (e) {
            $m.util.fail(param,e);
        }).run();
    }

    Seal.prototype.verifyCert=function (param) {
        this.imp.verifyCert(param)
    }

    Seal.prototype.verifySeal=function (param) {
        this.imp.verifySeal(param)
    }

    Seal.prototype.signSealHash=function (param){
        var that=this;
        var suffix="oes"
        if(this.imp.context.indexOf(suffix, this.imp.context.length - suffix.length) !== -1){
            that.imp.signSealHash(param)
        }else{
            this._assertSealLogined(param,function (){
                that.imp.signSealHash(param)
            })
        }
    }

    Seal.prototype.oesGetSealImageById=function (param){
        this.imp.oesGetSealImageById(param)
    }

    Seal.prototype.oesGetProviderInfo=function (param){
        this.imp.oesGetProviderInfo(param)
    }

    Seal.prototype.getPluginInfo=function (param){
        this.imp.getPluginInfo(param)
    }

    Seal.prototype.selectSealHash=function (param){
        var that=this
        var selectSeal;
        var selectCert;
        var sealB64;
        var certB64;
        var oes={}
        var suffix="oes"
        var isOes= this.imp.context.indexOf(suffix, this.imp.context.length - suffix.length) !== -1
        var seq=new $m.Seq();
        seq.then(function (){
            that.selectSeal({
                success:function (seal){
                    selectSeal=seal
                    seq.resolve()
                },
                fail:function (e){
                    seq.reject(e)
                }
            })
        }).then(function (){
            that.getSealB64({
                sealSn: selectSeal.sealSn,
                success:function (sealB64Data){
                    sealB64=sealB64Data
                    seq.resolve()
                },
                fail:function (e){
                    seq.reject(e)
                }
            })
        }).then(function (){
            that._getMiddleware({
                success:function (m){
                    seq.resolve(m)
                },
                fail:function (e){
                    seq.reject(e)
                }
            })
        }).then(function (seq,m){
            if(!isOes){
                m.getCertInfo({
                    sn: selectSeal.certSn,
                    success: function (cert) {
                        selectCert=cert
                        certB64 = cert.cert;
                        seq.resolve()
                    },
                    fail: function (e) {
                        seq.reject(e)
                    }
                })
            }
            else{
                seq.resolve()
            }
        }).then(function (){
            if(isOes){
                that.oesGetSealImageById({
                    plugin: selectSeal.plugin,
                    sealId: selectSeal.sealSn,
                    success: function (info) {
                        oes.imageWidth=info.width
                        oes.imageHeight=info.height
                        seq.resolve()
                    },
                    fail: function (e) {
                        seq.reject(e)
                    }
                })
            }else{
                seq.resolve()
            }
        }).then(function (){
            if(isOes){
                that.oesGetProviderInfo({
                    plugin: selectSeal.plugin,
                    success: function (info) {
                        oes.providerName=info.name
                        oes.providerCompany=info.company
                        oes.providerVersion=info.version
                        seq.resolve()
                    },
                    fail: function (e) {
                        seq.reject(e)
                    }
                })
            }else{
                seq.resolve()
            }
        }).then(function (){
            $m.util.success(param,{
                sealSn: selectSeal.sealSn,
                seal: sealB64,
                cert: certB64,
                certSn: selectSeal.certSn,
                certId: selectCert.certId,
                oes: oes
            })
        }).onerror(function (e){
            $m.util.fail(param,e)
        }).run()
    }

    Seal.prototype.handSign=function (param){
        var that=this;
        var seq=new $m.Seq();
        seq.then(function () {
            //签章
            var p={
                success:function (signature) {
                    seq.resolve(signature);
                },
                fail:function (e) {
                    seq.reject(e);
                }
            };
            $m.util.setAttrs(p,param,["data","certSn","dataFormat","charset","password",
                "zoomSize","handSignType",
                "deviceFilter","certCnFilter",
                "certVerify","enableTimeStamp"]);
            that.imp.handSign(p);
        }).then(function (seq,signature) {
            //显示
            if(param.show && param.show.divId){
                that.showSeal({
                    sealSignature: signature,
                    show: param.show,
                    success: function (){
                        seq.resolve(signature)
                    },
                    fail:function (e){
                        seq.reject(e)
                    }
                })
            }
            else {
                seq.resolve(signature);
            }
        }).then(function (seq,signature) {
            $m.util.success(param,signature);
        }).onerror(function (e) {
            $m.util.fail(param,e);
        });
        seq.run();
    }

    Seal.prototype.close=function (){
        this.imp.close()
    };

    $m.Seal=Seal;

})(HebcaMiddleware);
